import { metaAdapter } from '@/adapters/meta';

export const vacancyAdapter = (data) => {
  return {
    id: data.id,
    groupId: data.group_id,
    name: data.name,
    description: data.description?.map((descriptionItem) => ({
      title: descriptionItem.title,
      text: descriptionItem.text,
    })),
  };
};
export const vacanciesAdapter = ({ data, meta }) => {
  return {
    vacancies: data.map((event) => vacancyAdapter(event, true)),
    meta: metaAdapter(meta),
  };
};

const groupAdapter = (data) => {
  return {
    id: data.id,
    name: data.name,
  };
};
export const groupsAdapter = (data) => {
  return data.map(groupAdapter);
};
